import type {
  CreateTaskPayload,
  ProjectWithTasks,
  TaskWithSubtasks,
  UpdateTaskPayload,
} from '~/types';

import { apiRequest } from './client';
import { buildTaskEndpoint, buildTasksEndpoint, HTTP_METHODS } from './config';

export interface TaskUpdateResponse {
  task: TaskWithSubtasks;
  project: ProjectWithTasks;
}

export async function createTask(task: CreateTaskPayload): Promise<TaskWithSubtasks> {
  const { projectId } = task;

  if (!projectId) {
    throw new Error('Project ID is required to create a task');
  }

  const response = await apiRequest<TaskWithSubtasks>(buildTasksEndpoint(projectId), {
    method: HTTP_METHODS.POST,
    body: JSON.stringify(task),
  });

  return response.data;
}

export async function deleteTask(projectId: string, taskId: string): Promise<void> {
  await apiRequest(buildTaskEndpoint(projectId, taskId), {
    method: HTTP_METHODS.DELETE,
  });
}

export async function getProjectTasks(projectId: string): Promise<TaskWithSubtasks[]> {
  const response = await apiRequest<TaskWithSubtasks[]>(buildTasksEndpoint(projectId));
  // Defensive fallback for array endpoints that might return null/undefined
  return response.data ?? [];
}

export async function getTask(projectId: string, taskId: string): Promise<TaskWithSubtasks> {
  const response = await apiRequest<TaskWithSubtasks>(buildTaskEndpoint(projectId, taskId));

  return response.data;
}

export async function updateTask(
  projectId: string,
  taskId: string,
  updates: UpdateTaskPayload,
): Promise<TaskUpdateResponse> {
  const response = await apiRequest<TaskUpdateResponse>(buildTaskEndpoint(projectId, taskId), {
    method: HTTP_METHODS.PATCH,
    body: JSON.stringify(updates),
  });

  return response.data;
}
